export interface Response {
  ok: boolean;
}

async function closeInfoStripe() {
  return;
}

export default closeInfoStripe;
